<template>
  <div class="flex-col" :style="{ flex: '1 1 100%' }">
    <!-- TOP ROW -->
    <TopRow :part="part" :grouped_by="this.grouped_by" class="my-2"/>

    <!-- PART ROW EXTENSION -->
    <BottomRow :specificConditionText="part.specificConditionText" :info="part.info || ''" />
  </div>
</template>

<script>
export default {
  props: {
    part: {
      type: Object,
      required: true,
    },
    grouped_by: {
      type: String,
      required: true
    }
  },
  components: {
    TopRow: () => import('./TopRow.desktop'),
    BottomRow: () => import('./BottomRow.desktop'),
  }
}
</script>